class HvCollapsibleContent extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.hv-collapsible-content__toggle');
    this.body = this.querySelector('.hv-collapsible-content__body');
    this.parentDetails = this.closest('details');
    if (!this.toggle || !this.body) return;

    this.showMoreLabel = this.toggle.dataset.showMore;
    this.showLessLabel = this.toggle.dataset.showLess;

    if (this.body.scrollHeight <= this.body.clientHeight + 1) {
      this.classList.add('is-expanded');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.toggle.hidden = true;
      return;
    }

    this.onToggle = this.onToggle.bind(this);
    this.onParentClose = this.onParentClose.bind(this);

    this.toggle.addEventListener('click', this.onToggle);
    this.parentDetails?.addEventListener('toggle', this.onParentClose);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.onToggle);
    this.parentDetails?.removeEventListener('toggle', this.onParentClose);
  }

  collapse() {
    this.classList.remove('is-expanded');
    this.toggle.setAttribute('aria-expanded', 'false');
    this.toggle.textContent = this.showMoreLabel;
  }

  onParentClose() {
    if (!this.parentDetails?.open) {
      this.collapse();
    }
  }

  onToggle() {
    const expanded = this.classList.toggle('is-expanded');
    this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    this.toggle.textContent = expanded ? this.showLessLabel : this.showMoreLabel;
  }
}

if (!customElements.get('hv-collapsible-content')) {
  customElements.define('hv-collapsible-content', HvCollapsibleContent);
}
